import React, { useState } from "react";
import {
  eachDayOfInterval,
  endOfMonth,
  startOfMonth,
  getDay,
  format,
} from "date-fns";



const WorkHeatmapLeetCode = ({ workData,initialYear = new Date().getFullYear() }) => {
  const [year, setYear] = useState(initialYear);


  const getColor = (dateStr) => {
  const hours = workData[dateStr] || 0;

  if (hours === 0) return "#e2e2e2ff"; // pure white for 0 hours

  const clamped = Math.min(hours, 8);
  const percent = clamped / 8; // 0 to 1
  const lightness = 90 - percent * 60; // 90% → 30%
  return `hsl(120, 60%, ${lightness}%)`; // green tone based on intensity
};

  // Build each month block with weeks
  const renderMonthBlock = (monthIndex) => {
    const start = startOfMonth(new Date(year, monthIndex, 1));
    const end = endOfMonth(start);
    const days = eachDayOfInterval({ start, end });

    // Pad to start on Sunday
    const startPadding = getDay(start); // 0 (Sun) to 6 (Sat)
    const paddedDays = Array(startPadding).fill(null).concat(days);

    // Split into weeks
    const weeks = [];
    for (let i = 0; i < paddedDays.length; i += 7) {
      weeks.push(paddedDays.slice(i, i + 7));
    }

    return (
      <div key={monthIndex} className="flex flex-col items-center mr-2">
        <div className="text-xs text-gray-600 mb-1">{format(start, "MMM")}</div>
        <div className="flex">
          {weeks.map((week, weekIdx) => (
            <div key={weekIdx} className="flex flex-col gap-[4px] mr-[1px]">
              {week.map((day, dayIdx) =>
                day ? (
                  <div
                    key={dayIdx}
                    className="w-4 h-4 rounded-sm"
                    style={{ backgroundColor: getColor(format(day, "yyyy-MM-dd")) }}
                    title={`${format(day, "yyyy-MM-dd")}: ${Math.floor((workData[format(day, "yyyy-MM-dd")] || 0) * 60 / 60)}h ${Math.round((workData[format(day, "yyyy-MM-dd")] || 0) * 60 % 60)}m`}
                  />
                ) : (
                  <div key={dayIdx} className="w-4 h-4" />
                )
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
  <div className="ml-4 mb-6  bg-gray-50 shadow-2xl rounded-sm pb-5 max-w-[97%]">
    {/* Year Selector */}

    <div className="flex justify-between pt-2">
      <div className="flex items-center gap-1 px-6 pt-2 pb-0">
          {[...Array(9)].map((_, i) => {
            const percent = i / 8;
            const lightness = 90 - percent * 60;
            const color = i === 0 ? "#e2e2e2ff" : `hsl(120, 60%, ${lightness}%)`;
            return (
              <div key={i} className="flex flex-col items-center text-[10px] text-gray-500">
                <div
                  className="w-4 h-4 rounded-sm border border-gray-300"
                  style={{ backgroundColor: color }}
                  title={`${i} hour${i === 1 ? "" : "s"}`}
                />
                <span className="mt-1">{i}h</span>
              </div>
            );
          })}
        </div>
    
    <div className="mb-3 p-5 pt-4 pb-0 text-right">
      <select
  value={year}
  onChange={(e) => setYear(Number(e.target.value))}
  className="border border-gray-400 rounded px-2 py-0 text-sm "
>
  {Array.from({ length: 5 }, (_, i) => {
    const current = new Date().getFullYear();
    const y = current - i;
    return (
      <option key={y} value={y}>
        {y === current ? `${y}` : y}
      </option>
    );
  })}
</select>
    </div>


    </div>
    

    {/* Week + Calendar Grid */}
    <div className="flex items-start p-4 pr-1 pt-1">
      
      {/* Weekday Labels */}
      <div className="flex flex-col text-xs text-gray-400 mr-2 mt-5">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <div key={day} className="h-4 w-6 mb-[4px]">{day}</div>
        ))}
      </div>

      {/* Month Blocks */}
      <div className="flex gap-[2px]  pb-2 ">
        {Array.from({ length: 12 }, (_, i) => renderMonthBlock(i))}
      </div>
    </div>
        
  </div>
);

};

export default WorkHeatmapLeetCode;
